import { Data } from '../../../database.schema';
import { useFetchData } from '../tournament-data';

export const useFetchPlayers = () => {
  return useFetchData((data: Data) => {
    return data.players;
  });
};

export const useFetchOnTourPlayers = () => {
  return useFetchData((data: Data) => {
    return data.players.filter((player) => player.onTour);
  });
};
